<div class="container mx-auto md:pt-12 sm:pt-6 pt-6">
    <ng-container *ngIf="this.status == 'success';else paymentFailed">
        <div>
            <h4 class="standard-heading text-center">Payment Success</h4> 
        </div>
        <div class="mt-6 text-center">
            <img src="assets/images/ui/payment_success.png" class="md:w-52 sm:w-36 w-36 mx-auto mb-4" alt="">
            <div class="mb-4">
                <p class="text-center text-lg">Your payment has successfully been processed!</p>
            </div>
            <button class="mb-4" routerLink="/wallet-transaction" mat-flat-button class="bg-blue-theme-color text-white-color mx-auto">Thank You!</button>
        </div>
    </ng-container>
    <ng-template #paymentFailed>
        <div>
            <h4 class="standard-heading text-center !text-orange-color">Payment Failed</h4> 
        </div>
        <div class="mt-6 text-center">
            <img src="assets/images/ui/payment_failed.png" class="md:w-52 sm:w-36 w-36 mx-auto mb-0" alt="">
            <div class="mb-4">
                <p class="text-center text-lg">Your payment has failed. Please try again.</p>
            </div>
            <button class="mb-4" routerLink="/wallet-transaction" mat-flat-button class="bg-blue-theme-color text-white-color mx-auto">Thank You!</button>
        </div>
    </ng-template>
</div>